import {
  useEffect,
  useState
} from 'react';
import axios from 'axios';

export default function useMovieSearch(query, page) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [movies, setMovies] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setMovies([]);
  }, [query]);

  // Function to make API request with exponential backoff
  async function makeApiRequest(url, params, options, delay = 1000) {
    try {
      const response = await axios.get(url, {
        params,
        ...options
      });
      return response.data;
    } catch (error) {
      if (error?.response?.status === 429) {
        // If API returns 429 Too Many Requests, retry after a delay
        const retryAfterHeader = error.response.headers['retry-after'];
        const retryAfter = retryAfterHeader ? parseInt(retryAfterHeader) * 1000 : delay;
        await new Promise(resolve => setTimeout(resolve, Math.max(delay, retryAfter)));
        return makeApiRequest(url, params, options, delay * 2); // Double the delay for exponential backoff
      } else {
        console.error('Error:', error);
        throw error;
      }
    }
  }

  useEffect(() => {
    setLoading(true);
    setError(false);
    let cancel;
    const params = {
      'api-key': 'OshE8MJc67n55swlUL62XGqaeZbfyWAe',
      'fq': 'section_name:"Movies" AND type_of_material:"Review"',
      q: query,
      sort: 'newest',
      page
    };
    makeApiRequest('https://api.nytimes.com/svc/search/v2/articlesearch.json', params, {
        cancelToken: new axios.CancelToken((c) => (cancel = c))
      })
      .then((res) => {
        setMovies((prevMovies) => {
          const moviesData = res?.response?.docs || [];
          return [...new Set([...prevMovies, ...moviesData])];
        });
        setHasMore(res.response?.meta?.offset + 10 < res.response?.meta?.hits);
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        setError(true);
      });
    return () => cancel();
  }, [query, page]);

  return {
    loading,
    error,
    movies,
    hasMore
  };
}